import React from 'react';
import ImageModal from './ImageModal';

function Navbar({ active }) {
  const [openLogo, setOpenLogo] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [mesadasDropdownOpen, setMesadasDropdownOpen] = React.useState(false);
  const mesadasTimeoutRef = React.useRef(null);
  
  const items = [
    { key: 'cocina', label: 'Cocina' },
    { key: 'combos', label: 'Combos' },
    { key: 'muebles', label: 'Muebles' }
  ];

  const mesadasSubmenu = [
    { key: 'mesadas', label: 'Marmolina' },
    { key: 'mesadas-madera', label: 'Madera' },
    { key: 'mesadas-acero', label: 'Acero' },
    { key: 'mesadas-premium', label: 'Premium' }
  ];

  const isMesadasActive = active === 'mesadas' || active === 'mesadas-madera' || active === 'mesadas-acero' || active === 'mesadas-premium';

  React.useEffect(() => {
    const close = () => setMenuOpen(false);
    window.addEventListener('resize', close);
    return () => window.removeEventListener('resize', close);
  }, []);

  const handleMesadasMouseEnter = () => {
    if (mesadasTimeoutRef.current) {
      clearTimeout(mesadasTimeoutRef.current);
      mesadasTimeoutRef.current = null;
    }
    setMesadasDropdownOpen(true);
  };

  const handleMesadasMouseLeave = () => {
    mesadasTimeoutRef.current = setTimeout(() => {
      setMesadasDropdownOpen(false);
    }, 300); // 300ms de delay antes de ocultar
  };

  React.useEffect(() => {
    return () => {
      if (mesadasTimeoutRef.current) {
        clearTimeout(mesadasTimeoutRef.current);
      }
    };
  }, []);

  return (
    <nav className="tm-navbar">
      <div className="tm-logo">
        <button onClick={() => setOpenLogo(true)} aria-label="Abrir logo" className="tm-logo-btn">
          <img src="/assets/img/logo/jva.jpg" alt="JV@" />
        </button>
      </div>

      <button className="tm-burger" aria-label="Abrir menú" aria-expanded={menuOpen} onClick={() => setMenuOpen(v => !v)}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`tm-navlist ${menuOpen ? 'open' : ''}`}>
        {items.slice(0, 1).map(item => (
          <li key={item.key} onClick={() => setMenuOpen(false)}>
            <a
              href={`#${item.key}`}
              className={active === item.key ? 'active' : ''}
              aria-current={active === item.key ? 'page' : undefined}
            >
              {item.label}
            </a>
          </li>
        ))}
        
        <li 
          className={`tm-nav-dropdown ${mesadasDropdownOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(false)}
          onMouseEnter={handleMesadasMouseEnter}
          onMouseLeave={handleMesadasMouseLeave}
        >
          <a
            href="#mesadas"
            className={isMesadasActive ? 'active' : ''}
            aria-current={isMesadasActive ? 'page' : undefined}
          >
            Mesadas
            <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '4px', display: 'inline-block', verticalAlign: 'middle' }}>
              <path d="M6 9L1 4h10z"/>
            </svg>
          </a>
          <ul className="tm-nav-dropdown-menu">
            {mesadasSubmenu.map(subItem => (
              <li key={subItem.key}>
                <a
                  href={`#${subItem.key}`}
                  className={active === subItem.key ? 'active' : ''}
                >
                  {subItem.label}
                </a>
              </li>
            ))}
          </ul>
        </li>

        {items.slice(1).map(item => (
          <li key={item.key} onClick={() => setMenuOpen(false)}>
            <a
              href={`#${item.key}`}
              className={active === item.key ? 'active' : ''}
              aria-current={active === item.key ? 'page' : undefined}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
      <ImageModal open={openLogo} src="/assets/img/logo/jva.jpg" alt="Logo JV@" onClose={() => setOpenLogo(false)} />
    </nav>
  );
}

export default Navbar;



